module.exports = __webpack_public_path__ + "img/logo.ba9560bf.png";